<script>
  let { label, value, sublabel = null, loading = false, tone = 'default' } = $props();
  const tones = {
    default: 'var(--p-text)',
    success: 'var(--p-success)',
    warning: 'var(--p-warning)',
    danger:  'var(--p-danger)',
  };
</script>

<div class="p-card p-4">
  <p class="text-xs font-medium uppercase tracking-wide p-muted">{label}</p>
  {#if loading}
    <div class="mt-2 h-7 w-20 animate-pulse rounded" style="background-color: var(--p-bg-inset)"></div>
  {:else}
    <p class="mt-1 text-2xl font-semibold" style="color: {tones[tone] ?? tones.default}">{value}</p>
  {/if}
  {#if sublabel}<p class="mt-1 text-xs p-faint">{sublabel}</p>{/if}
</div>
